// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 3574) return "static/chunks/3574-fb8dcfc201b52ab7.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 3070 ? "8012d7e2" : chunkId) + "." + {"3070":"5599e30d17832c5e","3406":"5aceb25e309417a7"}[chunkId] + ".js";
};